import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { LEAVE_QUERY_KEYS } from './keys';

import * as userService from 'services/user';

interface LeaveBalanceParam {
  userId?: string | number;
  fiscalYearId?: string | number;
}

interface LeaveBalanceItem {
  leaveType: string;
  leaveTypeId: number;
  leaveCredits: number;
  leavesTaken: number;
  available: number;
  eligible?: number;
}
type LeaveBalanceResponse = Record<string, LeaveBalanceItem>;

export function useFetchLeaveBalance(
  param: LeaveBalanceParam = {},
  shouldFetch = true
): UseQueryResult<LeaveBalanceItem[]> {
  return useQuery<{ data: LeaveBalanceResponse }, Error, LeaveBalanceItem[]>({
    queryKey: [LEAVE_QUERY_KEYS.LEAVE_BALANCE, param.userId, param.fiscalYearId],
    queryFn: () => userService.fetchLeaves({ ...param, onlyActive: true }) as Promise<{ data: LeaveBalanceResponse }>,
    enabled: Boolean(param.userId) && Boolean(param.fiscalYearId) && shouldFetch,
    select: (response) => Object.values(response.data || {}),
  });
}
